/**
 * Largest image the upload accepts. Above it the upload is refused with a message,
 * never scaled down — factsheets are printed (agreed with SQUAD 29.10.2026).
 * nginx and Express (UPLOAD_MAX_FILE_BYTES) both allow 5 MiB; nginx counts the whole
 * multipart request, so leave room for its headers.
 */
export const UPLOAD_MAX_FILE_BYTES = 5 * 1024 * 1024 - 16 * 1024;

/** The limit as the customer reads it. */
export const UPLOAD_MAX_FILE_MB = 5;

export function isUploadWithinLimit(file: { size: number } | null | undefined): boolean {
  if (!file) return false;
  return file.size <= UPLOAD_MAX_FILE_BYTES;
}

/** Text for a failed upload: the limit message uploadImage throws, else a generic one. */
export function uploadErrorMessage(error: unknown): string {
  const msg = (error as { msg?: unknown } | null)?.msg;
  return typeof msg === 'string' && msg ? msg : 'Upload failed. Please try again.';
}

export function uploadLimitExceededMessage(fileSize?: number): string {
  const mb = UPLOAD_MAX_FILE_MB;
  if (fileSize != null && Number.isFinite(fileSize)) {
    const actual = (fileSize / (1024 * 1024)).toFixed(1);
    return `File is too large (${actual} MB). Maximum upload size is ${mb} MB.`;
  }
  return `File is too large. Maximum upload size is ${mb} MB.`;
}
